import styled from 'styled-components';
import SVG from 'react-inlinesvg';
import { themeGet } from '@styled-system/theme-get';
import { space } from 'styled-system';

import { Right } from '../../../../assets';
import i18n from '../../../../app/i18n';
import Text from '../../../../shared/Text';

import useDropdown from '../../../../lib/hooks/useDropdown';

const tabs = [
  { id: 'unscheduled', name: i18n.t('campaigns:shelf.unscheduled') },
  { id: 'suggested', name: i18n.t('campaigns:shelf.suggested') },
  { id: 'archived', name: i18n.t('campaigns:shelf.archived') },
];

export const ShelfHeader = ({ tiles, selectedTab, setSelectedTab }) => {
  const {
    dropdownRef,
    buttonRef,
    showDropdown,
    setShowDropdown,
  } = useDropdown();

  const DropDown = () => {
    return (
      <>
        <SelectionWrapper
          selectable
          onClick={() => setShowDropdown(state => !state)}
          ref={buttonRef}
        >
          <Chevron selected={showDropdown} src={Right} />
          <TileTypeLabel>{selectedTab}</TileTypeLabel>
          <TileCount variant="small1">{tiles[selectedTab].length}</TileCount>
        </SelectionWrapper>
        {showDropdown && (
          <Menu ref={dropdownRef}>
            {tabs.map(tab => (
              <Item
                key={tab.id}
                onClick={() => {
                  setSelectedTab(tab.id);
                  setShowDropdown(false);
                }}
              >
                <RadioButton
                  mr="10px"
                  type="radio"
                  checked={tab.id === selectedTab}
                />
                {tab.name}
              </Item>
            ))}
          </Menu>
        )}
      </>
    );
  };

  return (
    <DropdownWrapper>
      <DropDown />
    </DropdownWrapper>
  );
};

const SelectionWrapper = styled.div`
  padding: 20px;
  cursor: ${props => (props.selectable ? 'pointer' : 'default')};
  display: flex;
  align-items: center;
  border-bottom: 1px solid ${themeGet('colors.black.10')};
  justify-content: center;
`;

const DropdownWrapper = styled.div`
  position: relative;
`;

const Menu = styled.ul`
  position: absolute;
  right: 5px;
  top: 50px;
  box-shadow: 0px 0px 8px rgba(37, 40, 43, 0.12);
  border-radius: 8px;
  width: 200px;
  background: white;
  z-index: 1;
`;

const Item = styled.li`
  padding: 16px 20px 16px;
  cursor: pointer;
  display: flex;
  align-items: center;

  &:hover {
    background: ${themeGet('colors.primary.10')};
  }
`;

const Chevron = styled(SVG)`
  width: 16px;
  height: 16px;
  path {
    transform: rotate(90deg);
    transform-box: fill-box;
    transform-origin: center;
    ${props => props.selected === true && 'transform: rotate(270deg);'}
  }
`;

const RadioButton = styled.input`
  ${space}
`;

const TileTypeLabel = styled.div`
  margin-left: 10px;
  text-transform: capitalize;
`;

const TileCount = styled(Text)`
  margin-left: 10px;
  border: 1px solid ${themeGet('colors.black.80')};
  color: ${themeGet('colors.black.80')};
  border-radius: 30px;
  padding: 0px 6px;
`;
